import {ADMIN_ROOT_API_URL} from "../../../../config/settings.js"

export const UPDATE_PASSWORD = ADMIN_ROOT_API_URL +  "/update_password";